module.exports = __webpack_public_path__ + "logo.png?20b97be232a3b206c9d3c841cff8e411";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 887
// module chunks = 0